// import "@scripts/main/modules/sidebar";
import Acc from "./Acc";
import FixedHeader from "./FixedHeader";
import Modal from "./Modal";
import FreecallModal from "./FreecallModal";
import SortTable from "./SortTable";



window.app = {}

window.addEventListener('DOMContentLoaded', () => {
  'use strict';

  const 
    headerEl = document.querySelector('.header');

  new FixedHeader({
    element: headerEl,
    threshold: headerEl.offsetHeight,
    classToToggle: 'header--colored'
  });


  const
    accEl = document.querySelector('.acc'),
    expandAccBtn = document.getElementById('expand-acc'),
    collapseAccBtn = document.getElementById('collapse-acc'),
    acc = new Acc(accEl);

  if (expandAccBtn) expandAccBtn.addEventListener('click', () => acc.expandItems())
  if (collapseAccBtn) collapseAccBtn.addEventListener('click', () => acc.collapseItems())

  // Инициализация стандартных модальных окон приложения
  new Modal()
  
  // Инициализация модального окна обратной связи
  new FreecallModal()


  // Сортировка таблицы (ожидается что таблица на странице одна либо отсутствует)
  // const tableEl = document.querySelector('.table.table-bordered')
  // if (tableEl) new SortTable(tableEl)
  // Отключил - требует корректировок, на данныый момент не позволяет нормально сортировать, например, цены вида 110340 тнг
  // как из-за присутствия текста, так и из-за наличия других вложенных элементов внутри td ячейки
  
});


window.addEventListener('load', () => {
  'use strict';
});